import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import { DatePicker } from 'antd';
import Button from 'antd/lib/button';
import { ConfirmModal } from '../../../common/components';
import moment from 'moment';
import { formatDate } from '../../../common/utils/helpers';
import message from 'antd/lib/message';

@translate()
export default class EarlyRepaymentModal extends Component {
  static propTypes = {    
    t: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    handleModalCancel: PropTypes.func.isRequired,
    getEarlyRepaymentAmount: PropTypes.func.isRequired,
    amount: PropTypes.number,
    rozdiel: PropTypes.number,
    amountNonPayedPrincipal: PropTypes.number,
    amountFee: PropTypes.number,
    penaltyFee: PropTypes.number,
    nearestRepaymentDate: PropTypes.date,
    repaymentDate: PropTypes.string,
    earlyRepayLoan: PropTypes.func.isRequired,
  };

  handleDateChange = date => {
    this.props.getEarlyRepaymentAmount(date);
  };

  componentDidMount(){
    this.props.getEarlyRepaymentAmount(moment().add(1,'day'));
  }

  render() {
    const { visible, handleModalCancel, amount, rozdiel, amountNonPayedPrincipal, amountFee, penaltyFee ,nearestRepaymentDate, repaymentDate, earlyRepayLoan, t, modalActions } = this.props;

    return (
      <Modal
        title={t('Predčasné splatenie')}
        visible={visible}
        onCancel={handleModalCancel}
        footer={null}
      >
        <div className='text-center'>
          <DatePicker
            allowClear={false}
            showToday={false}
            onChange={this.handleDateChange}
            format={'DD.MM.YYYY'}
            value={repaymentDate ? moment(repaymentDate) : moment()}
          />
          <dl>
            <dt>{t('Najbližší dátum na predčasné splatenie je: ')}{nearestRepaymentDate ? formatDate(nearestRepaymentDate) : ''}</dt>
            <dt>&nbsp;</dt>
            <dt>{t('Suma na predčasné splatenie – celkom: ')}{typeof amount === 'number' ? `${amount.toFixed(2)} €` : '-'}</dt>
            <dt><small>{t('- z toho – nesplatená istina a splatný úrok: ')}{typeof amountNonPayedPrincipal === 'number' ? `${amountNonPayedPrincipal.toFixed(2)} €` : '-'}</small></dt>
            <dt><small>{t('- z toho – poplatok za predčasné splatenie: ')}{typeof amountFee === 'number' ? `${amountFee.toFixed(2)} €` : '-'}</small></dt>
            <dt><small>{t('- z toho – sankčné poplatky: ')}{typeof penaltyFee === 'number' ? `${penaltyFee.toFixed(2)} €` : '-'}</small></dt>
            <dt>&nbsp;</dt>
            <dt>{t('Ostáva zaplatiť: ')}{typeof rozdiel === 'number' ? `${rozdiel.toFixed(2)} €` : '-'}</dt>
          </dl>
          <ConfirmModal
            onSubmit={() => { earlyRepayLoan(moment(nearestRepaymentDate));                              
                              
                }}
            message={t('Naozaj chcete predčasne splatiť túto pôžičku?')}
          >
          <Button disabled={rozdiel > 0 || typeof rozdiel !== 'number'} type="primary">{t('Predčasne splatiť pôžičku')}</Button>
          </ConfirmModal>
        </div>
      </Modal>
    );
  }
}




// WEBPACK FOOTER //
// ./src/features/loan-management/components/EarlyRepaymentModal.js